export function isCanonicalGamePath(
  gameType: string,
  pathname: string,
): boolean {
  const basePath = `/${gameType}`;
  return (
    pathname === `${basePath}/lobby` ||
    pathname.startsWith(`${basePath}/games/`) ||
    pathname.startsWith(`${basePath}/replay/`)
  );
}

export function isPlatformGamePath(
  gameType: string,
  pathname: string,
): boolean {
  return isCanonicalGamePath(gameType, pathname);
}
